import { render } from "./floatMicrophoneClosed.vue?vue&type=template&id=1e4e0627"
const script = {}

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__